// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"93bd793f","703":"5a8e1167"}[chunkId] + ".chunk.js";
};